import React from 'react'
import cx from 'classnames'
import { Link, navigate } from '@reach/router'
import { H4, Intent, Classes } from '@blueprintjs/core'
import { Button, Callout, Flex, PrettyNumber, Link as SLink } from '@ui'
import useImportSummary from './hooks/useImportSummary'
import useImportMovePlan from './hooks/useImportMovePlan'
import { DateUtil, pluralize } from '@utils'
import { Event } from '../hooks/useImportDetails'
import { navigateToAphrodite } from '@utils/navigateToAphrodite'
import { legacyMode } from 'App'
// import moment from 'moment'
import css from './importFlow.module.scss'

interface ImportSummaryProps {
  id: string
  onClose: () => void
}

export default function ImportSummary({ id, onClose }: ImportSummaryProps) {
  const { loading, error, summary } = useImportSummary(id)
  const { plan } = useImportMovePlan()

  if (error) {
    return (
      <Callout faIcon="exclamation-triangle" intent={Intent.DANGER}>
        {error.message}
      </Callout>
    )
  }

  const items: { label: string; filter?: Event; value: number }[] = [
    {
      label: 'Total',
      /* eslint-disable @typescript-eslint/ban-ts-comment */
      // @ts-ignore
      filter: '',
      value: summary.totalCount,
    },
    {
      label: 'Created',
      filter: 'created',
      value: summary.createdCount,
    },
    {
      label: 'Updated',
      filter: 'updated',
      value: summary.updatedCount,
    },
    {
      label: 'Deleted',
      filter: 'destroyed',
      value: summary.destroyedCount,
    },
    {
      label: 'Failed',
      filter: 'failed',
      value: summary.failedCount,
    },
  ]

  return (
    <>
      <div style={{ padding: '30px 60px 60px 60px' }}>
        <H4 style={{ marginBottom: 30 }}>Import Summary</H4>
        <Flex>
          {items.map((item) => (
            <Link key={item.label} to={`/employees/history/${id}?filter=${item.filter}`}>
              <Card {...item} className={loading ? Classes.SKELETON : ''} />
            </Link>
          ))}
        </Flex>
        {plan && Boolean(summary.seatedCount) && (
          <p style={{ marginTop: 20 }}>
            You have {summary.seatedCount} new seating{' '}
            {(pluralize(summary.seatedCount), 'assignment')} based on this update. Please go to{' '}
            <SLink
              onClick={() => {
                if (legacyMode) {
                  const planId = `${DateUtil(plan?.deployAt).format('MMM-Do-gggg')}-${plan?.name}`
                  navigateToAphrodite(`/move_orders&planId=${planId}`)
                  return
                }

                navigate(`/move_orders&planId=${plan?.id}`)
              }}
            >
              Move Plan
            </SLink>{' '}
            to confirm and finalize these moves.
          </p>
        )}
      </div>
      <Flex align="center" justify="flex-end" style={{ height: 50 }}>
        <Button style={{ width: 100 }} intent={Intent.PRIMARY} text="Done" onClick={onClose} />
      </Flex>
    </>
  )
}

interface ICard {
  label: string
  value: number
  className?: string
}

export function Card({ label, value, className }: ICard) {
  return (
    <div className={cx(css.wrapper, className)}>
      <div className={css.value}>
        <PrettyNumber value={value} />
      </div>
      <div className={css.label}>{label}</div>
    </div>
  )
}
